import { useState } from 'react';
import { translations, Language } from './translations';
import HomePage from './components/HomePage';
import AboutPage from './components/AboutPage';
import ProductPage from './components/ProductPage';
import CaseStudiesPage from './components/CaseStudiesPage';
import LegalPage from './components/LegalPage';
import Navigation from './components/Navigation';
import Footer from './components/Footer';

export default function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [language, setLanguage] = useState<Language>('ru');

  const t = translations[language];

  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage t={t.home} language={language} />;
      case 'about':
        return <AboutPage t={t.about} language={language} />;
      case 'product':
        return <ProductPage t={t.product} language={language} />;
      case 'case-studies':
        return <CaseStudiesPage t={t.caseStudies} language={language} />;
      case 'warranty':
        return (
          <LegalPage
            t={t.legalInformation}
            title={t.footer.links.warranty}
            type="warranty"
            language={language}
          />
        );
      case 'purchase':
        return (
          <LegalPage
            t={t.legalInformation}
            title={t.footer.links.purchase}
            type="purchase"
            language={language}
          />
        );
      case 'privacy':
        return (
          <LegalPage
            t={t.legalInformation}
            title={t.footer.links.privacy}
            type="privacy"
            language={language}
          />
        );
      default:
        return <HomePage t={t.home} language={language} />;
    }
  };

  return (
    <div className="min-h-screen bg-[#1A1A1A] text-white">
      <Navigation
        t={t.nav}
        currentPage={currentPage}
        onPageChange={(page) => {
          setCurrentPage(page);
          window.scrollTo(0, 0); // Вот правильный способ!
        }}
        language={language}
        onLanguageChange={setLanguage}
      />

      <main>{renderPage()}</main>

      <Footer t={t.footer} nav={t.nav} onPageChange={(page) => {
          setCurrentPage(page);
          window.scrollTo(0, 0); // Вот правильный способ!
        }} />
    </div>
  );
}
